export default function Footer() {
  return (
    <footer className="bg-white">
      {/* Bottom Bar */}
      <div className="border-t py-4 text-center text-gray-700 text-sm">
        Design and Developed By :-{" "}
        <span className="font-medium text-blue-600">VRSamadhan Tech Solution</span>
      </div>
    </footer>
  );
}
